import actions from 'actions/requisitions'
import { createFormViewContainer } from 'factories/FormView'
import {
  createChildItemsDispatchToProps,
  createDocumentsDispatchToProps,
  createLinkedItemsDispatchToProps,
} from 'helpers/formViews'
import documentActions from 'actions/documents'
import requisitionItemActions from 'actions/requisitions/requisitionItems'
import locationActions from 'actions/locations'
import userActions from 'actions/users'
import formInstanceActions from 'actions/formInstances'
import Component from 'components/Requisitions/FormView'

export default createFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    newItem: (params) => dispatch(actions.newItem(params)),
    getAddressList: (params) => dispatch(locationActions.getAddressList(params)),
    populateRequisitionItems: (params) => dispatch(requisitionItemActions.populateRequisitionItems(params)),
    saveRequisition: (params) => dispatch(actions.saveRequisition(params)),
    deleteRequisition: (requisitionId) => dispatch(actions.deleteItem(requisitionId)),
    cancelRequisition: (params) => dispatch(actions.cancelRequisition(params)),
    closeRequisition: (params) => dispatch(actions.closeRequisition(params)),
    emailRequisition: (params) => dispatch(actions.emailRequisition(params)),
    sendRequisition: (params) => dispatch(actions.sendRequisition(params)),
    resendRequisition: (params) => dispatch(actions.resendRequisition(params)),
    approveRequisition: (params) => dispatch(actions.approveRequisition(params)),
    unapproveRequisition: (params) => dispatch(actions.unapproveRequisition(params)),
    getRequisitionSendToList: (params) => dispatch(userActions.getRequisitionSendToList(params)),
    ...createDocumentsDispatchToProps(dispatch, documentActions),
    ...createChildItemsDispatchToProps(dispatch, 'Requisition', requisitionItemActions),
    ...createLinkedItemsDispatchToProps(dispatch, 'FormInstance', formInstanceActions),
  }),
})(Component)
